import {
  Box,
  Divider,
  TablePagination,
  Typography,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { UserTablePaginationActions } from '../pagination/UserTablePaginationActions'
import { PaginatedTablePaginationActions } from '../pagination/PaginatedTablePaginationActions'

const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 500,
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
  },
}))

const Container = styled(Box)(({ theme }) => ({
  position: 'sticky',
  bottom: 0,
  backgroundColor: 'white',
  zIndex: 2,
  borderTop: '1px solid #e0e0e0',
  fontSize: '14px',
  paddingRight: '10px',
  paddingLeft: '10px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
  },
}))

interface TableFooterProps {
  rowsPerPage: number
  totalCount: number
  page: number
  onPageChange: (event: unknown, newPage: number) => void
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const PaginatedTableFooter: React.FC<TableFooterProps> = ({
  rowsPerPage,
  totalCount,
  page,
  onPageChange,
  onRowsPerPageChange,
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Container>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          py: 1,
          overflowX: 'hidden',
        }}
      >
        {!isMobile && (
          <StyledTypography>Total Entries: {totalCount}</StyledTypography>
        )}
        <TablePagination
          rowsPerPageOptions={[10, 20, 30, 40, 50, 100]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
          ActionsComponent={PaginatedTablePaginationActions}
          labelRowsPerPage={isMobile ? '' : 'Rows Per Page'}
        />
      </Box>
    </Container>
  )
}
